"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import CuoButton from "@/app/admin/_common/CuoButton";
import { useLinksModel } from "./linksPageModel";
import LinksToolbar from "./_cmp/LinksToolbar";
import LinkList from "./_cmp/LinkList";
import LinkListSkeleton from "./_cmp/LinkListSkeleton";
import { LinkDialog } from "./_cmp/linkForm/LinkDialog";
import { PlusCircle, Link2 } from "lucide-react";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function LinksPage() {
  const isMobile = useIsMobile();
  const {
    filteredLinks,
    isLoading,
    search,
    setSearch,
    sourceFilter,
    setSourceFilter,
    mediumFilter,
    setMediumFilter,
    mediums,
    sources,
    openForm,
    openCreateForm,
    closeForm,
    handleDelete,
    copyLinkUrl,
    refetch,
  } = useLinksModel();

  const addButton = (
    <CuoButton
      variant={isMobile ? "outline" : "default"}
      label={<span className="hidden sm:inline">Add link</span>}
      icon={<PlusCircle className="size-3.5 shrink-0" size={14} />}
      onClick={openCreateForm}
      className="px-2 sm:px-3"
      aria-label="Add link"
    />
  );

  const toolbar = (
    <LinksToolbar
      search={search}
      onSearchChange={setSearch}
      sourceFilter={sourceFilter}
      onSourceFilterChange={setSourceFilter}
      mediumFilter={mediumFilter}
      onMediumFilterChange={setMediumFilter}
      sources={sources}
      mediums={mediums}
    />
  );

  const list = isLoading ? (
    <LinkListSkeleton />
  ) : (
    <LinkList links={filteredLinks} onDelete={handleDelete} onCopy={copyLinkUrl} />
  );

  const dialog = <LinkDialog open={openForm} onClose={closeForm} onSaved={refetch} />;

  if (isMobile) {
    return (
      <PageContainer flush>
        <div className="flex h-full w-full flex-col overflow-y-auto">
          <div className="sticky top-0 z-10 flex flex-col gap-2 border-b border-border bg-card/80 px-3 py-2 backdrop-blur-sm">
            <PageHeader
              title="Links"
              icon={Link2}
              subtitle={`${filteredLinks.length} links`}
              actions={addButton}
              className="static bg-transparent p-0 backdrop-blur-none"
            />
            {toolbar}
          </div>

          <div className="flex flex-1 flex-col pb-3">{list}</div>
        </div>

        {dialog}
      </PageContainer>
    );
  }

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader
          title="Links"
          icon={Link2}
          subtitle={`${filteredLinks.length} links`}
          actions={addButton}
        />

        <div className="flex min-h-0 flex-1 flex-col gap-3 px-5 py-5">
          {toolbar}

          <div className="flex min-h-0 flex-1 flex-col">{list}</div>
        </div>
      </div>

      {dialog}
    </PageContainer>
  );
}
